<template>
  <el-container class="up-main">
      <el-aside width="211px">
          <left-menu :active="2"></left-menu>
      </el-aside>
      <el-main class="u-main">
        <!-- 企业信息 -->
        <div class="d-form">
            <h3 class="h-title">用户信息</h3>
            <div class="f-b" v-if="isEdit == '0'">             
              <el-row :gutter="10" class="mb8">
                <el-col :span="1.5">
                  <el-button
                    type="orange"
                    size="mini"
                    @click="handleEdit"
                  >修改企业信息</el-button>
                </el-col>
              </el-row>
              <table class="user-table" cellspacing="0" cellpadding="0">
                  <tr>
                      <th width="20%">用户全称</th>
                      <td width="30%"> {{formDate.companyCn}}</td>
                      <th width="20%">用户类型</th>
                      <td width="30%"> {{formatType(formDate.userType)}}</td>
                  </tr>
                  <tr>
                      <th>统一社会信用代码</th>
                      <td>{{formDate.job}}</td>
                      <th>注册资本金</th>
                      <td>{{setComdify(formDate.regCapital,4)}} 万元</td>
                  </tr>
                  <tr>                 
                      <th>用户注册地</th>
                      <td style="padding: 0 20px">
                        <el-cascader
                            class="no-bg"
                            disabled  
                            style="width: 100%;"
                            placeholder=""
                            v-model="formDate.compCode"
                            :options="areaOptions">
                        </el-cascader>
                      </td>
                      <th>法定代表人姓名</th>
                      <td>{{formDate.legalPerson}}</td>
                  </tr>
                  <tr> 
                      <th>联系人</th>
                      <td>{{formDate.agencyPerson}}</td>
                      <th>用户地址详址</th>
                      <td>{{formDate.compAddr}}</td>                              
                  </tr>
                  <tr>
                      <th>联系人手机号</th>
                      <td>{{formDate.mobile}}</td>             
                      <th>联系人邮箱</th>
                      <td>{{formDate.email}}</td>
                  </tr>
                  <tr>
                      <th>营业执照</th>
                      <td colspan="3">
                        <div><a target="_bank" :href="formDate.licenseFile">营业执照</a></div>
                      </td>
                  </tr>
              </table>
            </div>

            <!-- 修改企业信息 -->
            <div class="f-b" v-else style="margin: 0 30px;">
              <el-form ref="companyForm" :model="companyForm" :rules="companyRules" label-position="left" label-width="140px" class="reg-form" > 
                <el-form-item label="用户全称" prop="companyCn"> 
                  {{companyForm.companyCn}}
                </el-form-item> 
                <el-form-item label="用户类型" prop="userType"> 
                    <el-select v-model="companyForm.userType" placeholder="请选择" style="width: 100%"> 
                      <el-option
                          v-for="dict in userTypenOptions"
                          :key="dict.dictValue"
                          :label="dict.dictLabel"
                          :value="dict.dictValue"
                      ></el-option>
                    </el-select> 
                </el-form-item> 
                <el-form-item label="统一社会信用代码" prop="job"> 
                    <el-input v-model.trim="companyForm.job" placeholder="请输入" /> 
                </el-form-item> 
                <el-form-item label="注册资本金(万元)" prop="regCapital"> 
                    <el-input-number v-model="companyForm.regCapital" controls-position="right" :precision="4" :step="0.1" :min="0" placeholder="请输入" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="用户注册地" prop="compCode">
                    <el-cascader
                        style="width: 100%"
                        v-model="companyForm.compCode"
                        :options="areaOptions">
                    </el-cascader>
                </el-form-item> 
                <el-form-item label="法定代表人姓名" prop="legalPerson"> 
                    <el-input v-model.trim="companyForm.legalPerson" placeholder="请输入" /> 
                </el-form-item> 
                <el-form-item label="联系人" prop="agencyPerson"> 
                    <el-input v-model.trim="companyForm.agencyPerson" placeholder="请输入" /> 
                </el-form-item> 
                <el-form-item label="用户地址详址" prop="compAddr"> 
                    <el-input v-model.trim="companyForm.compAddr" placeholder="请输入" /> 
                </el-form-item> 
                <el-form-item label="联系人邮箱" prop="email"> 
                    <el-input v-model.trim="companyForm.email" placeholder="请输入" /> 
                </el-form-item>
                <el-form-item label="联系人手机号" prop="mobile"> 
                    <el-input v-model.trim="companyForm.mobile" :maxlength="11" placeholder="请输入" /> 
                </el-form-item> 
                <el-form-item label="营业执照" prop="licenseFileList"> 
                    <el-upload 
                      :on-success="(response,file) => handlePictureSuccess('licenseFile',response,file)" 
                      :before-upload="handleBeforeUpload" 
                      :on-error="handleUploadError" 
                      :limit="1" 
                      :headers="upload.headers" 
                      :action="upload.url" 
                      :on-remove="(file, fileList) => handleRemove('licenseFile',file, fileList)"
                      :file-list="companyForm.licenseFileList"> 
                      <el-button size="small" type="orange">上传</el-button>
                    </el-upload> 
                </el-form-item> 
                <el-form-item>
                  <el-button class="s-but" type="orange" @click="handleCanel">取消</el-button>
                  <el-button class="s-but" type="orange" @click.native="handleSumit" :loading="butLoading">修改</el-button>
                </el-form-item>
                  
              </el-form> 
            </div>

        </div>         
      </el-main>
  </el-container>
</template>

<script>
import leftMenu from './components/leftMenu'
import area from '@/utils/area'
import baseUrl from '@/api/baseUrl.js' 
export default {
  name: "cUser",
  components: {
    leftMenu
  },
  data() {
    return {
      butLoading: false,
      setComdify: this.comdify,
      areaOptions:area,
      account: sessionStorage.account,
      formDate: {},
       // 用户导入参数
       upload: {
          // 是否显示弹出层（用户导入）
          open: false,
          // 弹出层标题（用户导入）
          title: "",
          // 是否禁用上传
          isUploading: false,
          // 是否更新已经存在的用户数据
          updateSupport: 0,
          // 设置上传的请求头部
          // headers: { Authorization: "Bearer " + this.getToken() },
          // 上传的地址
          url: baseUrl.newucUrl + "/usercenter/user/uplodFile"
      },
      // 表单校验
      companyRules:{
          userType:[
              { required: true, message: "用户类型不能为空", trigger: "blur" }
          ],
          job: [
              { required: true, message: "统一社会信用代码不能为空", trigger: "blur" }
          ],
          regCapital: [
              { required: true, message: "注册资本金不能为空", trigger: "blur" }
          ],
          compCode: [
                  { required: true, message: "地址不能为空", trigger: "change" }
              ], 
          legalPerson: [
                  { required: true, message: "法人代表姓名不能为空", trigger: "blur" }
              ],
            agencyPerson: [
                  { required: true, message: "联系人不能为空", trigger: "blur" }
              ],
          compAddr: [
                  { required: true, message: "机构联系地址不能为空", trigger: "blur" }
              ], 
          email:[
              {
              required: true,
              pattern:  /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
              message: "请输入正确的邮箱",
              trigger: "blur"
              },
          ],
          mobile: [
              { required: true, message: "联系人手机号不能为空", trigger: "blur"    },
              {
                  pattern: /^1[0-9][0-9]\d{8}$/,
                  message: "请输入正确的手机号码",
                  trigger: "blur"
              },   
          ],
          licenseFileList: [
              { required: true, message: '营业执照不能为空', trigger: 'change' }
          ], 
      },            
      userTypenOptions: [],
      isEdit: '0',
      companyForm: {}
    }
  },
  created() {
    this.$api.api.getDicts("user_type").then(response => {
      this.userTypenOptions = response.data;
    }); 
    this.getInf()
  },
  methods: {
    handleCanel(){
      this.isEdit = '0'
    },
    handleSumit(){
      this.$refs.companyForm.validate(valid => {
        if (valid) {
          if(!this.companyForm.licenseFileList){
            this.$message({
              type: "error",
              message: "营业执照不能为空",
            });
            return false
          }
          if(this.companyForm.compCode){
              this.companyForm.compProvinceCode = this.companyForm.compCode[0]
              this.companyForm.compCityCode = this.companyForm.compCode[1]
              this.companyForm.compDistrictCode = this.companyForm.compCode[2]
          }
          
          this.companyForm.attrValues = [{attrKey: 'licenseFile', attrValue: this.companyForm.licenseFile }] 
          var formData = new FormData();
          for(let i in this.companyForm){
            if(i != 'attrValues'){
                  formData.append(i, this.companyForm[i])
            }
          }

          this.companyForm.attrValues.map((item,i) =>{
              formData.append(`attrValuesList[${i}].attrKey`, item.attrKey)
              formData.append(`attrValuesList[${i}].attrValue`, item.attrValue)
          })
          console.info(this.companyForm.licenseFile)
          this.butLoading = true
          this.$api.api.editUser(formData).then(res => {
              this.butLoading = false
              if (res.code == 200) {
                  this.loading = false;
                  this.$message.success("修改成功")
                  this.isEdit = '0'
                  this.getInf()
              }else{
                  this.$message.error(res.msg)
              }             
          });
        }
      })
    },
    handleEdit(){
      this.isEdit = '1'
    },
    formatType(val){  
      if(val){
        return this.userTypenOptions.filter(item=>item.dictValue == val)[0].dictLabel
      }        
    },
    getInf(){
      this.$api.api.iaccGetInfoByAccount({account: this.account}).then(response => {
        this.formDate = response.data
        // 入会申请书
        let fileAttach2File = response.data.userAttrValues.filter(item => {
          return item.attrKey == 'fileAttach2'
        })
        this.formDate.fileAttach2 =fileAttach2File.length >0 ? fileAttach2File[0].attrValue :''

        // 邮箱
        let orgEmail = response.data.userAttrValues.filter(item => {
          return item.attrKey == 'orgEmail'
        })
        this.formDate.orgEmail =orgEmail[0]?orgEmail[0].attrValue : ''
        // 企业类型
        let compType = response.data.userAttrValues.filter(item => {
          return item.attrKey == 'compType'
        })
        this.formDate.compType =compType[0]?compType[0].attrValue : ''
        // 省
        this.formDate.compCode = [this.formDate.compProvinceCode,this.formDate.compCityCode,this.formDate.compDistrictCode]

        this.companyForm = {...this.formDate}
        
        // 营业执照
        let licenseFile = response.data.userAttrValues.filter(item => {
          return item.attrKey == 'licenseFile'
        })
        if(licenseFile.length > 0){
          this.formDate.licenseFile = licenseFile[0].attrValue  
          this.companyForm.licenseFile = licenseFile[0].attrValue                  
          this.companyForm.licenseFileList = [{
            url: licenseFile[0].attrValue ,
            name: '营业执照'
          }]
        }

      });
    },
    handleUploadError() {
        this.$message({
        type: "error",
        message: "上传失败",
        });
        this.loading.close();
    },
    handlePictureSuccess(key,res, file){
        this.$refs.companyForm.clearValidate(key)
        this.companyForm[key+'List'] = [{
          url: res.msg ,
          name: file.name
        }]
        this.companyForm[key] = res.msg
        this.loading.close();
    }, 
    handleRemove(key,file, fileList) {
      delete this.companyForm[key+'List']
      this.companyForm[key] = ''
    },
    handleBeforeUpload() {
        this.loading = this.$loading({
            lock: true,
            text: "上传中",
            background: "rgba(0, 0, 0, 0.7)",
        });
    }
  }
}
</script>

<style lang="less">
@import '../style.less';
.user-table{
  width: 100%;
  border-right: 1px solid #F1F1F1;
  border-bottom: 1px solid #F1F1F1;
  font-size: 14px;
}
.user-table td, .user-table th {
  border-left: 1px solid #F1F1F1;
  border-top: 1px solid #F1F1F1;
  padding: 15px 20px;
}
.user-table th{font-weight: bold;}
</style>
